import React from 'react';

const Transformation = ({ transform, children }) => (
    <g transform={transform}>
        {children}
    </g>
)

export default Transformation
